import { View } from 'react-native';

import { cn } from '@/components/ui/cn';
import { Surface } from '@/components/ui/Surface';

import { NoteEntry, type NoteEntryData } from './NoteEntry';

/** Oldest-to-newest thread of immutable notes on a step. */
export function NoteThread({
  notes,
  bubble,
  className,
}: {
  notes: NoteEntryData[];
  /** Wrap each note in a card (sealed-run timeline); the caller supplies the
   *  left inset, so the default `ml-9` is dropped. */
  bubble?: boolean;
  className?: string;
}) {
  if (notes.length === 0) return null;
  if (bubble) {
    return (
      <View className={cn('gap-2', className)}>
        {notes.map((n) => (
          <Surface key={n.id} variant="card" className="px-3 py-2">
            <NoteEntry author={n.author} time={n.time} body={n.body} late={n.late} />
          </Surface>
        ))}
      </View>
    );
  }
  return (
    <View className={cn('ml-9 gap-3', className)}>
      {notes.map((n) => (
        <NoteEntry
          key={n.id}
          author={n.author}
          time={n.time}
          body={n.body}
          late={n.late}
        />
      ))}
    </View>
  );
}
